import { render } from "./BulletList.vue?vue&type=template&id=ebe39694"
import script from "./BulletList.vue?vue&type=script&lang=js"
export * from "./BulletList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-management\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__